export default __webpack_public_path__ + "static/media/tryout.07997ae5.png";